import { t } from '../../app/i18n';

export default {
  WAITING_SIGNATURE: 'WAITING_SIGNATURE',
  WAITING_CONFIRMATION: 'WAITING_CONFIRMATION',
  WAITING_INSURANCE_SIGNATURE: 'WAITING_INSURANCE_SIGNATURE',
  WAITING_INSURANCE_CONFIRMATION: 'WAITING_INSURANCE_CONFIRMATION',
  PENDING: 'PENDING',
  INVESTED: 'INVESTED',
  REJECTED: 'REJECTED',
  DISPOSED: 'DISPOSED',
  SOLD: 'SOLD',
  // custom frontend-only states
  PARTIALLY_INVESTED: 'PARTIALLY_INVESTED',
};

export const translation = {
  WAITING_SIGNATURE: t('Čaká sa na podpísanie príkaznej zmluvy'),
  WAITING_INSURANCE_SIGNATURE: t('Čaká sa na podpísanie zmluvy o poistení'),
  WAITING_INSURANCE_CONFIRMATION: t('Čaká sa na potvrdenie zmluvy o poistení SMS kódom'),
  WAITING_CONFIRMATION: t('Čaká sa na potvrdenie SMS kódom'),
  PENDING: t('Čaká sa na napárovanie'),
  INVESTED: t('Investovaná'),
  REJECTED: t('Zamietnutá'),
  DISPOSED: t('Odpredaná'),
  SOLD: t('Predaná'),
  // custom frontend-only states
  PARTIALLY_INVESTED: t('Čiastočne investovaná'),
};



// WEBPACK FOOTER //
// ./src/common/enums/allocationStatus.js